import React, { useEffect, useState } from "react";

import { useSelector } from 'react-redux';

import { Document, Page, pdfjs } from "react-pdf";
import Draggable from 'react-draggable';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { ILabelInfo } from "../../../../shared/interfaces";
import { reduxActions, RootState } from "../../../../store";
import { store } from "../../../..";
import { DocumentLoading_State, LabelOrientation } from "../../../../shared/enums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CircleLoader from "../../../Loader/CircleLoader/CircleLoader";


export interface LabelPositionProps {
    base64String?: string
}
type Props = LabelPositionProps

const LabelPosition: React.FunctionComponent<Props> = props => {

    pdfjs.GlobalWorkerOptions.workerSrc = process.env.PUBLIC_URL + '/pdf.worker.min.js';

    const [currentBase64String, setCurrentBase64String] = useState<string | undefined>(props.base64String);

    const nodeRef = React.useRef(null);

    const selectCurrentState = (state: RootState) => state.protocolWizardReducer;
    const protocolWizardState = useSelector(selectCurrentState);
    const [documentLoadingState, setDocumentLoading] = useState<DocumentLoading_State>(DocumentLoading_State.Loading);



    // const [currentScale, setCurrentScale] = useState<number>(1.0);
    //const selectCurrentLabelInfo = (state: RootState) => state.createProtocolReducer.labelInfo;
    //const currentLabelInfo: ILabelInfo = useSelector(selectCurrentLabelInfo);
    //const selectPageScaledHeight = (state: RootState) => state.createProtocolReducer.pageScaledHeight;
    //const pageScaledHeight = Number(useSelector(selectPageScaledHeight));

    //const selectPageScaledWidth = (state: RootState) => state.createProtocolReducer.pageScaledWidth;
    //const pageScaledWidth = Number(useSelector(selectPageScaledWidth));

    // componentDidMount
    useEffect(() => {
        setDocumentLoading(DocumentLoading_State.Loading);

        if (!protocolWizardState.labelInfo) {
            let labelInfo: ILabelInfo = {
                labelOrientation: LabelOrientation.Orizzontale,
                positionX: 0,
                positionY: 0,
                labelWidth: 170,
                labelHeight: 75,
                scale: 1.0
            };
            store.dispatch(reduxActions
                .protocolWizardActions
                .updateProtocolWizardState({
                    labelInfo: labelInfo
                })
            );

        }
    }, []);

    useEffect(() => {
        if (props.base64String) {
            setDocumentLoading(DocumentLoading_State.Loading);
            setCurrentBase64String('data:application/pdf;base64,' + props.base64String)
        }
        else {
            setDocumentLoading(DocumentLoading_State.NoData);
        }
    }, [props.base64String]);


    const onDocumentLoadSuccess = (pdf) => {
        setDocumentLoading(DocumentLoading_State.LoadSuccess);

        let { protocol } = protocolWizardState;

        if (protocol.fields) {
            let fields = [...protocol.fields];
            let numPagineFieldIndex = fields.findIndex(f => f.internalName === 'PagineDocumento');
            if (numPagineFieldIndex !== -1) {
                let numPagineField = { ...fields[numPagineFieldIndex] };
                numPagineField.internalValue = pdf.numPages
                fields[numPagineFieldIndex] = numPagineField;
                protocol.fields = [...fields];
                store.dispatch(reduxActions
                    .protocolWizardActions
                    .updateProtocolWizardState({
                        ...protocolWizardState,
                        ...protocol
                    })
                );
            }
        }

    }
    function onDocumentError() {
        setDocumentLoading(DocumentLoading_State.LoadError);
    }

    const onPageLoad = (page) => {
        let rotate = page.rotate;
        let originalWidth = page.originalWidth;
        let originalHeight = page.originalHeight;
        if (rotate === 90 || rotate === 270) {
            originalWidth = page.originalHeight;
            originalHeight = page.originalWidth;

        }


        /// calcolo lo scale del documento
        let pdfContainerWidth = document.getElementsByClassName('react-pdf__Page')[0]?.clientWidth;
        let pageScale = pdfContainerWidth / originalWidth
        pageScale = pageScale < 1.5 ? pageScale : 1.5;

        /// Aggiorno la dimensione del div overlap-dragbox-container che uso per definire i margini del drag
        let pageScaledWidth = pageScale * originalWidth;
        let pageScaledHeight = pageScale * originalHeight;
        let overlapDragboxContainer = document.getElementsByClassName('overlap-dragbox-container')[0];
        overlapDragboxContainer.setAttribute('style', `width: ${pageScaledWidth}px; height: ${pageScaledHeight}px;`);
        //////////////

        let { labelInfo } = protocolWizardState;


        if (labelInfo && labelInfo.scale !== pageScale) {
            labelInfo.scale = pageScale;
        }
        store.dispatch(reduxActions
            .protocolWizardActions
            .updateProtocolWizardState({
                ...protocolWizardState,
                pageScaledWidth: pageScaledWidth,
                pageScaledHeight: pageScaledHeight,
                labelInfo: labelInfo
            })
        );



        // let el = document.getElementsByClassName('drag-wrapper')[0];
        // el.setAttribute('style',
        //     `width: ${pageScale * currentLabelInfo.width}px;
        //     height: ${pageScale * currentLabelInfo.height}px; 
        //     transform: translate(${currentLabelInfo.positionX}px, ${currentLabelInfo.positionY}px);`);


    }

    const dragHandlers = (e, d) => {
        const { positionX, positionY } = protocolWizardState.labelInfo!;
        let newLabelInfo: any = {
            ...protocolWizardState.labelInfo,
            positionX: positionX + d.deltaX,
            positionY: positionY + d.deltaY
        };

        store.dispatch(reduxActions
            .protocolWizardActions
            .updateProtocolWizardState({
                ...protocolWizardState,
                labelInfo: newLabelInfo
            })
        );
    };


    useEffect(
        () => {
            if (protocolWizardState.labelInfo) {
                let labelInf = { ...protocolWizardState.labelInfo };
                let el = document.getElementsByClassName('drag-wrapper')[0];
                if (el) {
                    let positionX;
                    let positionY;
                    let width;
                    let height;

                    let diff;

                    switch (labelInf.labelOrientation) {
                        case LabelOrientation.Orizzontale:
                            positionX = labelInf.positionX;
                            positionY = labelInf.positionY;
                            width = labelInf.scale * labelInf.labelWidth;
                            height = labelInf.scale * labelInf.labelHeight;

                            diff = protocolWizardState.pageScaledWidth - labelInf.positionX - labelInf.labelWidth;
                            if (diff < 0) {
                                positionX = labelInf.positionX + diff;

                                let newLabelInfo: any = {
                                    ...protocolWizardState.labelInfo,
                                    positionX: positionX
                                }

                                store.dispatch(reduxActions
                                    .protocolWizardActions
                                    .updateProtocolWizardState({
                                        ...protocolWizardState,
                                        labelInfo: newLabelInfo
                                    })
                                );

                            }

                            break;
                        case LabelOrientation.Verticale:

                            positionX = labelInf.positionX;
                            positionY = labelInf.positionY;
                            width = labelInf.scale * labelInf.labelHeight;
                            height = labelInf.scale * labelInf.labelWidth;

                            diff = protocolWizardState.pageScaledHeight - labelInf.positionY - labelInf.labelWidth;
                            if (diff < 0) {
                                positionY = labelInf.positionY + diff;
                                let newLabelInfo: any = {
                                    ...protocolWizardState.labelInfo,
                                    positionY: positionY
                                }

                                store.dispatch(reduxActions
                                    .protocolWizardActions
                                    .updateProtocolWizardState({
                                        ...protocolWizardState,
                                        labelInfo: newLabelInfo
                                    })
                                );

                            }
                            break;
                    }

                    el.setAttribute('style',
                        `width: ${width}px;
                        height: ${height}px; 
                        transform: translate(${positionX}px, ${positionY}px);`);

                }
            }
        }, [protocolWizardState.labelInfo?.labelOrientation]
    );
    return (
        <React.Fragment>
            {(documentLoadingState === DocumentLoading_State.Loading) &&
                <div className="preview-document" style={{ position: 'relative', height: '100%', minHeight: '300px' }}>
                    <CircleLoader loaderClass='loader-large' loading={documentLoadingState === DocumentLoading_State.Loading} />
                </div >
            }
            {(documentLoadingState === DocumentLoading_State.LoadError) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'eye-slash' }} />
                    </div>
                    <h2 className="preview-document-description">Anteprima non disponibile</h2>
                </div >
            }
            {(documentLoadingState === DocumentLoading_State.NoData) &&
                <div className="preview-document">
                    <div className="preview-document-container">
                        <FontAwesomeIcon className="preview-document-icon" icon={{ prefix: 'far', iconName: 'file' }} />
                    </div>
                    <h2 className="preview-document-description">Nessun documento selezionato</h2>
                </div >
            }


            {(documentLoadingState !== DocumentLoading_State.LoadError && documentLoadingState !== DocumentLoading_State.NoData) &&
                <div className='pdf-document'>

                    <Document
                        file={currentBase64String}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={onDocumentError}
                    >
                        <Page pageNumber={1}
                            onLoadSuccess={onPageLoad}
                            scale={protocolWizardState.labelInfo?.scale} >
                        </ Page>

                        <div className='overlap-dragbox-container'>
                            {protocolWizardState.labelInfo &&
                                <Draggable
                                    bounds='.overlap-dragbox-container'
                                    position={{ x: protocolWizardState.labelInfo!.positionX, y: protocolWizardState.labelInfo!.positionY }}
                                    onDrag={dragHandlers}>
                                    <div ref={nodeRef}
                                        className='drag-wrapper'
                                        style={{
                                            width: protocolWizardState.labelInfo!.labelWidth * protocolWizardState.labelInfo!.scale,
                                            height: protocolWizardState.labelInfo!.labelHeight * protocolWizardState.labelInfo!.scale
                                        }}>
                                        <div>
                                            <FontAwesomeIcon icon={['fal', 'qrcode']} />
                                        </div>
                                    </div>
                                </Draggable>
                            }
                        </div>
                    </Document>
                </div>
            }


        </React.Fragment>
    );
}

export default LabelPosition;